/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Detail_Privacy_NoteInputs */



/**
* | output |
* | --- |
* | "Individual ratings carry no user identification to protect employee privacy." |
*
* @param {Feedback_Detail_Privacy_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_detail_privacy_note = /** @type {((inputs?: Feedback_Detail_Privacy_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Detail_Privacy_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzelbewertungen enthalten keine Nutzerkennung zum Schutz der Mitarbeitenden.")
	return /** @type {LocalizedString} */ ("Individual ratings carry no user identification to protect employee privacy.")
});